module.exports = __webpack_public_path__ + "img/model_6.82b5e75e.png";